module.exports = __webpack_public_path__ + "img/self_styling_mw_03.8f672604.jpg";